import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Enable Missing Ref Report.
 */
export const schema = z.boolean();

export type ReferenceNumReportEnabled = z.infer<typeof schema>;

export const definition = define({
  key: 'reference_num_report_enabled',
  schema,
  label: 'Missing Ref Report Enabled',
  description: 'Enable the missing reference number report feature for clients at this level.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.REFERENCE_NUMBER.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
